module.exports = __webpack_public_path__ + "static/media/check-black.0103ca6d.svg";